import { c as _c } from "react/compiler-runtime";
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faBookmark as solidBookmark } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as regularBookmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@xefi/x-react/tooltip';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToasts } from '@/hooks/useToasts';
import type { SurveyHome } from '@/models/survey';
import { usePinSurveyMutation } from '../../_hooks/usePinSurveyMutation';
type PinSurveyProps = {
  survey: SurveyHome;
};
export const PinSurvey = t0 => {
  const $ = _c(22);
  const {
    survey
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    addErrorToast
  } = useToasts();
  const pinSurveyMutation = usePinSurveyMutation();
  const [isPinned, setIsPinned] = useState(survey.pinners_exists);
  let t1;
  if ($[0] !== addErrorToast || $[1] !== isPinned || $[2] !== pinSurveyMutation || $[3] !== survey.id || $[4] !== t) {
    t1 = () => {
      const previous = isPinned ?? false;
      setIsPinned(!previous);
      pinSurveyMutation.mutate({
        surveyId: survey.id,
        isPinned: previous
      }, {
        onError: () => {
          setIsPinned(previous);
          addErrorToast(t("survey.pinned.error", {
            ns: "notifications"
          }));
        }
      });
    };
    $[0] = addErrorToast;
    $[1] = isPinned;
    $[2] = pinSurveyMutation;
    $[3] = survey.id;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleClickPinnable = t1;
  let t2;
  let t3;
  if ($[6] !== pinSurveyMutation.isPending || $[7] !== survey.pinners_exists) {
    t2 = () => {
      if (!pinSurveyMutation.isPending) {
        setIsPinned(survey.pinners_exists);
      }
    };
    t3 = [survey.pinners_exists, pinSurveyMutation.isPending];
    $[6] = pinSurveyMutation.isPending;
    $[7] = survey.pinners_exists;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] !== t) {
    t4 = t("survey.pinned");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== handleClickPinnable) {
    t5 = event => {
      event.stopPropagation();
      handleClickPinnable();
    };
    $[12] = handleClickPinnable;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isPinned) {
    t6 = isPinned ? <FontAwesomeIcon size="lg" icon={solidBookmark as IconProp} className="text-red-500" /> : <FontAwesomeIcon size="lg" icon={regularBookmark} />;
    $[14] = isPinned;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <button className="flex size-8 cursor-pointer items-center justify-center rounded-md transition-colors" onClick={t5}>{t6}</button>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t7) {
    t8 = <Tooltip content={t4} placement="top" size="sm" trigger={t7} />;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};